import { Pressable } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

      gap: theme.spacingInlineTwopulse,

      borderRadius: theme.borderRadiusPill,
    },
    variants: {
      variant: {
        'brand-primary': {
          borderWidth: theme.borderWidthNone,
          borderColor: theme.colorActionBorderBrandPrimaryEnabled,

          backgroundColor: theme.colorActionFillBrandPrimaryEnabled,
        },
        'neutral-secondary': {
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorActionBorderNeutralSecondaryEnabled,

          backgroundColor: theme.colorActionFillNeutralSecondaryEnabled,
        },
        'neutral-tertiary': {
          borderWidth: theme.borderWidthNone,
          borderColor: theme.colorActionBorderNeutralTertiaryEnabled,

          backgroundColor: theme.colorActionFillNeutralTertiaryEnabled,
        },
      },
      size: {
        md: {
          minWidth: theme.sizingMedium,
          height: theme.sizingMedium,

          paddingHorizontal: theme.paddingInsetFourpulse,
        },
        ml: {
          minWidth: theme.sizingMediumlarge,
          height: theme.sizingMediumlarge,

          paddingHorizontal: theme.paddingInsetFourpulse,
        },
        lg: {
          minWidth: theme.sizingLarge,
          height: theme.sizingLarge,

          paddingHorizontal: theme.paddingInsetFivepulse,
        },
        xl: {
          minWidth: theme.sizingExtralarge,
          height: theme.sizingExtralarge,

          paddingHorizontal: theme.paddingInsetSixpulse,
        },
      },
      hasFull: {
        true: {
          width: '100%',
        },
      },
      hasPressed: {
        true: {},
      },
      hasLoading: {
        true: {
          paddingHorizontal: theme.paddingInsetNone,
        },
      },
      hasOnlyIcon: {
        true: {
          paddingHorizontal: theme.paddingInsetNone,
        },
      },
      hasDisabled: {
        true: {},
      },
    },
    compoundVariants: [
      {
        variants: {
          variant: 'brand-primary',
          hasPressed: true,
        },
        css: {
          borderColor: theme.colorActionBorderBrandPrimaryPressed,
          backgroundColor: theme.colorActionFillBrandPrimaryPressed,
        },
      },
      {
        variants: {
          variant: 'brand-primary',
          hasDisabled: true,
        },
        css: {
          borderWidth: theme.borderWidthNone,
          borderColor: theme.colorActionBorderBrandPrimaryDisabled,

          backgroundColor: theme.colorActionFillBrandPrimaryDisabled,
        },
      },
      {
        variants: {
          variant: 'neutral-secondary',
          hasPressed: true,
        },
        css: {
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
        },
      },
      {
        variants: {
          variant: 'neutral-secondary',
          hasDisabled: true,
        },
        css: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
      {
        variants: {
          variant: 'neutral-tertiary',
          hasPressed: true,
        },
        css: {
          borderColor: theme.colorActionBorderNeutralTertiaryPressed,
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
        },
      },
    ],
  }
})
